module.exports = __webpack_public_path__ + "static/drag_and_drop_email.089d802d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/drag_and_drop_email.png
// module id = 215
// module chunks = 193162123475590 216210090109534